import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import {
  Toast
} from 'vant';
Vue.use(Vuex)
import {
  getUserInfo,
} from "@/api/api";
import { cacheInfo } from '@/model/cache'

export default new Vuex.Store({
  state: {
    guid: '',
    userInfo: null, // 现在使用的用户信息
    agentCode: 885,
    cardid: -1,
    configID: 0
  },
  mutations: {
    // 设置GUID
    SET_GUID: (state, guid) => {
      state.guid = guid
    },
    // 设置用户信息
    SET_USERINFO: (state, info) => {
      state.userInfo = info
    },
  },
  actions: {
    async setGuid({ commit, state }) {
      if (localStorage.getItem("guid"))
        commit('SET_GUID', localStorage.getItem("guid"))
      return state
    },
    async storeGetUserInfo({ commit, state }) {
      if (!state.userInfo) {
        let guid = state.guid
        if (!guid) guid = localStorage.getItem("guid")
        if (!guid) return null

        const {data:{data,status,msg}} = await getUserInfo({ guid })
          console.log(status,'---------------------')
        //  如果等于 401 或者 200，需要登录
        if (status == 401) {
          commit('SET_USERINFO', null)
          Toast(msg);
          router.push("/login")
        } else{
          commit('SET_USERINFO', data.data)
        }
      }
      return state.userInfo
    },
    async agent({ state }, { agentCode, cardID }) {
      state.agentCode = cacheInfo('agentCode', agentCode)
      state.cardid = cacheInfo('cardID', cardID)
    },
    async configID({ state }, { configID }) {
      state.configID = cacheInfo('configID', configID)
    },
  },
  modules: {
  }
})
